import React, { useEffect, useState } from 'react';

import { Typography } from '@sravni/react-design-system';

import { CUR_FETCH_PARAMS, CURRENCIES_DATA } from '../../constants/currencies';
import { decorateCurrencies } from '../../helpers/currencies';
import { getCbrfRates } from '../../services/currencies';

import styles from './currencies.module.scss';
import CurrencyItem from './item';

export const Currencies = React.memo(() => {
  const [curRates, setCurrencies] = useState([]);

  const fetchCurrencies = async () => {
    let res;

    try {
      res = await getCbrfRates(CUR_FETCH_PARAMS);
    } catch (error) {
      res = [];
    }

    setCurrencies(res);
  };

  useEffect(() => {
    fetchCurrencies();
  }, []);

  const rates = decorateCurrencies(curRates, {});

  return (
    <div className={`${styles.wrapper} ${styles.currency}`}>
      <div className={styles.content}>
        <div className={styles['content-inner']}>
          {CURRENCIES_DATA.map((item, index) => {
            const currency = rates && rates[item.code];
            return <CurrencyItem currency={currency} item={item} key={`currency-${index}`} />;
          })}
          <Typography.Text size={14} className={styles.link} strong>
            <Typography.Link href="/valjuty/">Все курсы</Typography.Link>
          </Typography.Text>
        </div>
      </div>
    </div>
  );
});
